// extracted by mini-css-extract-plugin
export default {"table":"Table_table__fr636","contet_table":"Table_contet_table__gqJkX"};